module.exports = __webpack_public_path__ + "img/480dc3b.jpg";